import React, { useState, useEffect } from "react";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";
import * as config from "../../../next.config.js";
import {useTheme } from "@mui/system";
// import Link from "next/link";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Rating from "@mui/material/Rating";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/system";
import { useRouter } from "next/router";
import { getCookieValue, printLogs } from "../../../components/helpers/helpers";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
// import { getWeekDates } from "../../helpers/helpers";
import { isOpenOrClose } from "../../helpers/global/datesTimes/datesTimesFunctions";
import {buidlObject} from "../../helpers/helpers";
const CustomeBadge = styled(Badge)(({ theme, locale }) => ({
  "& .MuiCheckbox-root": {
    padding: "16px"
  },
  "& .MuiBadge-badge": {
    left: locale == "ar" ? "3px" : "-15px",
    right: locale == "ar" ? "10px" : "20px",
    top: "11px",
    border: "1px solid #fff",
    padding: "0px 4px",
    backgroundColor: "#F52A59",
    color: "#fff",
    minWidth: "18px",
    width: "20px",
    height: "20px",
    minHeight: "18px",
    fontSize: "9px"
  },
  '@media only screen and  (min-width:280px){': {
    "& .MuiBadge-badge": {
      left: locale == "ar" ? "-14px" : "0px",
      right: locale == "ar" ? "10px" : "20px",
      width: "15px",
      height: "15px",
      border: "0px solid #fff",
      top: "-1px",
    }
  }
}));
function Diet(props) {
  const router = useRouter();
  const { t } = useTranslation("common");
  const theme = useTheme();
  // const [value, setValue] = React.useState(2);
  const [Open, setOpen] = useState(false);
  const [entityDetailsOpen, setEntityDetailsOpen] = useState(false);
  const [Text, setText] = useState("");
  const [Type, setType] = useState("");
  const [checkLogin, setcheckLogin] = React.useState(false);
  // const [checkOpen, setchekOpen] = React.useState(false);
  let entityDetails;
  let ratingDegree;
  let orderscount = 0; 
  printLogs("entityDetailsOpen",props)
  if (props.entityDetails != null) {
    entityDetails = props.entityDetails;

    ratingDegree =
      entityDetails.rating && entityDetails.rating.length > 0
        ? entityDetails.rating && entityDetails.rating[0].ratingDegree
        : "";
    orderscount =
      entityDetails.product && entityDetails.product.length > 0
        ? entityDetails.product.length
        : "";
  }
  
  let Authorization = getCookieValue("login");
const [showOpenOrClose,setShowOpenOrClose]=useState(false)
  useEffect(() => {
    if (entityDetails &&entityDetails.workTime &&entityDetails.workTime.length > 0) {       
      setEntityDetailsOpen(isOpenOrClose(entityDetails.workTime[0].entityWorkDays));
      }
    if (Authorization == false) {
      setcheckLogin(true);
    }

    if( entityDetails.fieldConfig != null
      && buidlObject(entityDetails.fieldConfig) &&
      buidlObject(entityDetails.fieldConfig).orderWorkTimeRestricted &&
      buidlObject(entityDetails.fieldConfig).orderWorkTimeRestricted == "true"){
        setShowOpenOrClose(true)
      }
  }, [props.entityDetails]);

  const handleCheck = e => {
   
    if (checkLogin == true) {
      setOpen(true);
      setText(t("ttlLoginFirst"));
      setType("login");
    } 
    else {
      let entityType= entityDetails.entityType.length>0&&entityDetails.entityType[0].code !="merchant"?entityDetails.entityType[0].code:entityDetails.entityCategories[0] &&entityDetails.entityCategories[0].entityCategories.length>0&&entityDetails.entityCategories[0].entityCategories[0].code
      let getSlug = entityDetails.slug.length > 0 && 
      entityDetails.slug.filter(i => i.active == true).length > 0        
      ? entityDetails.slug.filter(i => i.active == true)[0].url.replace("/[^a-zA-Z0-9-_]/g", "")
      : entityDetails.id      
      router.push(`/basket/${entityType}/${getSlug}`)        
    }
  };
  return (
    <div>
      <ConfirmDialog
        open={Open}
        text={Text}
        type={"Erorr"}
        btnOk={() => {
          setOpen(false);
          if (Type== "login") {
            setTimeout(() => {
              window.location =
                config.basePath + "/user-ms/login" + "?next=" + router.asPath;
            }, 1000);
          }
        }}
        btnCancel={()=>{
          setOpen(false);
        }}
        confirmBtnTitle={t("btnOk")}
      />
      {entityDetails && entityDetails != null ? (
        <a className={style.AtagIcon} onClick={handleCheck} style={{cursor:"pointer"}}>
        <div className={style.allcard3}>
          <div className={style.stylesResturantSoon}>
            <div className={style.Badge_POs}>
              <IconButton>
                <CustomeBadge locale={router.locale} badgeContent={props.quantity}>
                  <img
                    className={style.icontitle}
                    src={`${config.basePath}/assest/basket.svg`}
                  />
                </CustomeBadge>
              </IconButton>
            </div>

            <div className={style.cardDiet}>
                <div className={style.profileMedical}>
                  <div className={style.profileandtextcardfood}>
                    <div className={style.profile1}>
                      <div>
                        <img
                          className={style.cardImage}
                          src={
                            entityDetails.images &&
                            entityDetails.images.find(
                              x => x.imageType.code == "logo"
                            )&&entityDetails.images &&
                            entityDetails.images.find(
                              x => x.imageType.code == "logo"
                            ).image!=""&&entityDetails.images &&
                            entityDetails.images.find(
                              x => x.imageType.code == "logo"
                            ).image!=null
                              ? entityDetails.images &&
                                entityDetails.images.find(
                                  x => x.imageType.code == "logo"
                                ).image
                              :   `${config.basePath}/assest/logo.svg`
                          }
                        ></img>
                      </div>
                    </div>
                    <div className={style.profile2}>
                      <p
                        className={style.textaboutresturant1 + " " + style.Blod}
                      >
                        {entityDetails.transEntityDetails &&
                        entityDetails.transEntityDetails.length > 0
                          ? entityDetails.transEntityDetails[0].officialName
                          : ""}
                      </p>
                      <p className={style.textaboutdoctor3}>
                        {" "}
                        {entityDetails.addressDetails
                          ? entityDetails.addressDetails.map(i => {
                              if (i.permanent == true) {
                                let cityAddress =
                                  i.city &&
                                  i.city.filter(
                                    c => c.language.code == router.locale
                                  ).length > 0
                                    ? i.city.filter(
                                        c => c.language.code == router.locale
                                      )[0].name
                                    : "";
                                let countryAddress =
                                  i.country &&
                                  i.country.filter(
                                    c => c.language.code == router.locale
                                  ).length > 0
                                    ? i.country.filter(
                                        c => c.language.code == router.locale
                                      )[0].name
                                    : "";
                                let districtAddress =
                                  i.district &&
                                  i.district.filter(
                                    c => c.language.code == router.locale
                                  ).length > 0
                                    ? i.district.filter(
                                        c => c.language.code == router.locale
                                      )[0].name
                                    : "";
                                let physicalAddress =
                                  i.physicalAddress && i.physicalAddress;
                                return (
                                  <p>
                                    <LocationOnIcon sx={{ color: "#008C8D " }} />
                                    {countryAddress +
                                      " - " +
                                      cityAddress +
                                      " - " +
                                      districtAddress +
                                      " - " +
                                      physicalAddress}
                                  </p>
                                );
                              }
                            })
                          : ""}{" "}
                      </p>
                    </div>
                  </div>
                </div>
        
          
              <div className={style.profileMedical}>
                <div className={style.StarandDistance}>
                  <div>
                    <Rating
                      name="simple-controlled"
                      value={ratingDegree}
                      className={style.sizestars}
                      // onChange={(event, newValue) => {
                      //     setValue(newValue)
                      // }}

                      readOnly
                    />
                  </div>
                  <div>
                    {/* <div className={style.textminimun}>{t("Minimun")} : {+"  " + 1000}</div> */}
                  </div>
                  <div>
                    {/* <div className={style.Statesquare}>
                                        <p style={{ marginBottom: 0 }}>{t("Soon")}</p>
                                    </div> */}
                                     {/* <div className={style.Open  + " " + style.borderradiusTop }>
                        <p style={{ marginBottom: 0 }}>{t("Open")}</p>
                      </div> */}
                      {showOpenOrClose?entityDetailsOpen==false?<div className={style.Close  + " " + style.borderradiusTop }>
                        <p style={{ marginBottom: 0 }}>{t("Close")}</p>
                      </div>  :   <div className={style.Open  + " " + style.borderradiusTop }>
                        <p style={{ marginBottom: 0 }}>{t("Open")}</p>
                      </div>:""}
                    {/* { entityDetails.workTime &&
                              entityDetails.workTime.length > 0 &&
                              entityDetails.workTime[0].timesToday &&
                              entityDetails.workTime[0].timesToday.filter(
                                r =>
                                  r.fromTime <=
                                    (new Date().getHours() - 3) * 60 +
                                      new Date().getMinutes() &&
                                  r.toTime >
                                    (new Date().getHours() - 3) * 60 +
                                      new Date().getMinutes()
                              ).length > 0 ?  (
                      <div className={style.Open  + " " + style.borderradiusTop }>
                        <p style={{ marginBottom: 0 }}>{t("Open")}</p>
                      </div>
                    ) : (
                      <div className={style.Close  + " " + style.borderradiusTop }>
                        <p style={{ marginBottom: 0 }}>{t("Close")}</p>
                      </div>
                    )} */}

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </a>
      ) : (
        ""
      )}
    </div>
  );
}

export default Diet;
